export const TelegramIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
  >
    <path
      d="M7.5 0C3.36 0 0 3.36 0 7.5C0 11.64 3.36 15 7.5 15C11.64 15 15 11.64 15 7.5C15 3.36 11.64 0 7.5 0ZM10.98 5.1C10.8675 6.285 10.38 9.165 10.1325 10.4925C10.0275 11.055 9.8175 11.2425 9.6225 11.265C9.1875 11.3025 8.8575 10.98 8.4375 10.7025C7.7775 10.2675 7.4025 9.9975 6.765 9.5775C6.0225 9.09 6.5025 8.82 6.93 8.385C7.0425 8.2725 8.9625 6.525 9 6.3675C9.00521 6.34364 9.00452 6.31888 8.99798 6.29535C8.99145 6.27183 8.97927 6.25025 8.9625 6.2325C8.9175 6.195 8.8575 6.21 8.805 6.2175C8.7375 6.2325 7.6875 6.93 5.64 8.31C5.34 8.5125 5.07 8.6175 4.83 8.61C4.56 8.6025 4.05 8.46 3.6675 8.3325C3.195 8.1825 2.8275 8.1 2.8575 7.8375C2.8725 7.7025 3.06 7.5675 3.4125 7.425C5.6025 6.4725 7.0575 5.8425 7.785 5.5425C9.87 4.6725 10.2975 4.5225 10.5825 4.5225C10.6425 4.5225 10.785 4.5375 10.875 4.6125C10.95 4.6725 10.9725 4.755 10.98 4.815C10.9725 4.86 10.9875 4.995 10.98 5.1Z"
      fill="#2F7ED3"
    />
  </svg>
);
